import { useState } from 'react';
import { Switch } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import { CustomTableMeta } from '@/components/Tables/TableCard/TableCard.types';
import { PromotionStatusGroup } from '@/types/promotions.types';

export const SwitchCell = ({ row, table, column }: CellContext<PromotionStatusGroup, unknown>) => {
  const { original } = row;
  const { status, ...rest } = original;
  const { updateData } = table.options.meta as CustomTableMeta<PromotionStatusGroup>;
  const [checked, setChecked] = useState(status === 'Active');

  const handleClick = () => {
    const saveIsLock = !checked;
    setChecked(saveIsLock);
    updateData(row.index, column.id, `${saveIsLock ? 'Active' : 'Inactive'}`);
  };

  return <Switch color="error" title="switch" checked={status === 'Active'} onClick={() => handleClick()} {...rest} />;
};
